import Switch from '@mui/material/Switch';

import "./index.css";

export default function AntSwitch (props) {
    return (
        <Switch className='ant-switch' {...props} />
    )
}